import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutClassGroupWorkplaceRequest } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * クラスグループを作成
 * @param {PutClassGroupWorkplaceRequest} payload
 */
export async function storeClassGroupWorkplace(payload: PutClassGroupWorkplaceRequest) {
  const createdWorkplaceClasses = await shiftServiceRepositories.classGroupWorkplace.create(payload);
  return createdWorkplaceClasses;
}

/**
 * クラスグループを更新
 * @param {string} groupId
 * @param {PutClassGroupWorkplaceRequest} payload
 */
export async function updateClassGroupWorkplace(groupId: string, payload: PutClassGroupWorkplaceRequest) {
  const updatedWorkplaceClasses = await shiftServiceRepositories.classGroupWorkplace.update(groupId, payload);
  return updatedWorkplaceClasses;
}

export default {
  storeClassGroupWorkplace,
  updateClassGroupWorkplace,
};
